export function rotatingText() {
	const rotatingTextElements = document.querySelectorAll('[data-rotating-text]')

	const colors = [
		'var(--color-primary)',
		'var(--color-secondary-1)',
		'var(--color-secondary-2)',
		'var(--color-secondary-3)',
		'var(--color-secondary-4)',
	]

	rotatingTextElements.forEach(dataTestElement => {
		const texts = JSON.parse(dataTestElement.getAttribute('data-rotating-text'))
		const speed = parseInt(dataTestElement.getAttribute('data-rotating-text-speed'), 12)
		let currentIndex = 0

		// Store the first text in HTML (for SEO)
		const seoText = texts[0]

		// Create visual overlay for rotating text
		const visualOverlay = document.createElement('span')
		visualOverlay.setAttribute('aria-hidden', 'true')
		visualOverlay.style.position = 'relative'
		visualOverlay.style.display = 'inline-block'
		visualOverlay.style.transition = 'opacity 0.375s ease-in-out'

		// Keep original text in DOM but hide it visually
		dataTestElement.setAttribute('aria-live', 'polite')
		dataTestElement.innerHTML = `<span class="screen-reader-text">${seoText}</span>`
		dataTestElement.appendChild(visualOverlay)

		function measureTextWidth(text) {
			const tempElement = document.createElement('span')
			tempElement.style.visibility = 'hidden'
			tempElement.style.position = 'absolute'
			tempElement.style.whiteSpace = 'nowrap'
			tempElement.style.font = window.getComputedStyle(dataTestElement).font
			tempElement.textContent = text
			document.body.appendChild(tempElement)
			const width = tempElement.offsetWidth
			document.body.removeChild(tempElement)
			return width
		}

		function setText(text, index) {
			const textWidth = measureTextWidth(text)
			dataTestElement.style.width = `${textWidth}px`
			visualOverlay.textContent = text
			visualOverlay.style.color = colors[index % colors.length]
		}

		function setInitialText() {
			setText(texts[currentIndex], currentIndex)
			visualOverlay.style.opacity = 1
		}

		function cycleTexts() {
			visualOverlay.style.opacity = 0

			setTimeout(() => {
				currentIndex = (currentIndex + 1) % texts.length
				setText(texts[currentIndex], currentIndex)
				visualOverlay.style.opacity = 1
			}, 375)
		}

		setInitialText()
		setInterval(cycleTexts, speed)
	})
}

rotatingText()
